import React from "react";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import Card from "components/card";
import CardHeader from "@material-ui/core/CardHeader";
import styles from "./styles/card-with-delete.css.js";
import DeleteCardButton from "./partial/delete-button";
import DataGrid from "components/data-grid";

const CardWithDelete = ({ header, classes, onDelete, children }) => (
  <Card>
    <CardHeader avatar={header} className={classes.header} action={<DeleteCardButton onDelete={onDelete} />} />
    <DataGrid className={classes.content}>{children}</DataGrid>
  </Card>
);

CardWithDelete.propTypes = {
  /**
   * Elemento de cabecera
   */
  header: PropTypes.element,
  /**
   * Función que se invoca al eliminar el contacto del formulario
   */
  onDelete: PropTypes.func,
};

export default withStyles(styles)(CardWithDelete);
